"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCollectionDriver = void 0;
var tslib_1 = require("tslib");
var stylable_collection_1 = require("./stylable-collection");
var stylable_shorthands_1 = require("../stylable-shorthands");
var ImageCollectionDriver = /** @class */ (function (_super) {
    tslib_1.__extends(ImageCollectionDriver, _super);
    function ImageCollectionDriver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageCollectionDriver.prototype.router = function (decl, sheet, declarations) {
        var addImage = function (value, change) {
            if (declarations[value] === undefined) {
                declarations[value] = [];
            }
            declarations[value].push({ declaration: decl, change: change });
        };
        if (decl.prop === 'background' || decl.prop === 'background-image') {
            this.handleImageBackgroundProperty(sheet, decl.value, addImage);
        }
        else if (decl.prop === 'border-image' || decl.prop === 'border-image-source') {
            this.handleImageURLProperty(sheet, decl.value, addImage);
        }
    };
    ImageCollectionDriver.prototype.handleImageBackgroundProperty = function (sheet, declValue, adder) {
        var _this = this;
        var backgrounds = stylable_shorthands_1.splitLayers(sheet.evalDeclarationValue(declValue));
        backgrounds.forEach(function (layer) {
            _this.handleImageURLProperty(sheet, layer, adder);
        });
    };
    ImageCollectionDriver.prototype.handleImageURLProperty = function (sheet, declValue, adder) {
        var updateFromAST = this.updateFromAST.bind(this);
        var urlRegex = /url\(.*\)/;
        function changeURL(value) {
            var currEval = sheet.evalDeclarationValue(this.declaration.value);
            var currURLMatch = currEval.match(urlRegex);
            if (currURLMatch) {
                this.declaration.value = currEval.replace(currURLMatch[0], value);
                updateFromAST(this.declaration);
            }
        }
        var urlMatch = sheet.evalDeclarationValue(declValue).match(urlRegex);
        urlMatch && adder(urlMatch[0], changeURL);
    };
    return ImageCollectionDriver;
}(stylable_collection_1.CollectionDriver));
exports.ImageCollectionDriver = ImageCollectionDriver;
//# sourceMappingURL=image-collection.js.map